// src/shared/stores/useStores.ts
import { useUserStore } from './useUserStore';
import { usePanelsStore } from './usePanelsStore';
import { useRequestsStore } from './useRequestsStore';
import { getAndSanitize } from '../utils/sanitization';

// Function to preload all critical data at app start
export const preloadAppData = async (): Promise<boolean> => {
  try {
    
    // Get user ID from token
    const token = getAndSanitize('token');
    if (!token) return false;
    
    // Cargar datos del usuario
    const userId = localStorage.getItem('userId');
    if (userId) {
      // Fix: Don't destructure unused variables
      await Promise.all([
        useUserStore.getState().fetchUser(userId),
        // No cargar panels ya que no se usa
      ]);
      
      return true;
    }
    return false;
  } catch (error) {
    console.error('[GlobalStores] Error preloading application data:', error);
    return false;
  }
};

export { useUserStore, usePanelsStore, useRequestsStore };